<template>
  <div class="inventory-attachments">
    <artisio-tabs v-model="currentTab">
      <b-tab lazy :title="$t('Internal Images')">
        <attachment-list
          :delete-permission="'delete_inventoryitem'"
          :change-permission="'change_inventoryitem'"
          :object-uuid="inventory.uuid"
          plural-object-name="inventories"
          object-name="inventory"
          attachment-type="internal_image"
          :hide-header="true"
          :accept-only-images="true"
        />
      </b-tab>
      <b-tab lazy :title="$t('Attachments')">
        <attachment-list
          :delete-permission="'delete_inventoryitem'"
          :change-permission="'change_inventoryitem'"
          :object-uuid="inventory.uuid"
          plural-object-name="inventories"
          object-name="inventory"
          attachment-type="attachment"
          :hide-header="true"
          :exclude-images="true"
        />
      </b-tab>
    </artisio-tabs>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import AttachmentList from "@/modules/attachments/AttachmentList";
  import ArtisioTabs from "@/core/components/artisio-tabs/ArtisioTabs";

  const {mapState, mapActions} = createNamespacedHelpers('inventory');

  export default {
    name: "Attachments",
    components: {AttachmentList, ArtisioTabs},
    data() {
      return {
        currentTab: 0
      }
    },
    computed: {
      ...mapState({
        inventory: state => state.view.currentInventory,
        attachmentsCurrentTab: state => state.view.attachmentsCurrentTab,
      }),
    },
    methods: {
      ...mapActions(['updateAttachmentsCurrentTab']),
    },
    mounted() {
      this.currentTab = this.attachmentsCurrentTab
    },
    beforeDestroy() {
      this.updateAttachmentsCurrentTab(0)
    }
  }
</script>

<style scoped>
</style>
